import { Paragraph, classNames } from '@movingimage-evp/mi-ui-component-library';
import { t } from 'i18next';
import { type GetWebcastSummaryManagerQuery } from 'src/generated/graphql-manager';
import { getLanguageKey } from 'src/utils';

import { EventSummaryRecording } from '../event-summary-recording/event-summary-recording';
import { EventSummaryVod } from '../event-summary-vod/event-summary-vod';

import styles from './event-summary-video.module.css';

type EventSummaryVideoProps = {
  webcast: GetWebcastSummaryManagerQuery['webcast'];
  onVideoSelect: () => void;
};

export function EventSummaryVideo({ webcast, onVideoSelect }: EventSummaryVideoProps) {
  const recordingEnabled = webcast?.recordingSettings?.enabled;
  const primaryLanguage = webcast?.primaryLang;
  const additionalLanguages = webcast?.additionalLangs || [];
  const languages = [primaryLanguage, ...additionalLanguages];
  const multipleLanguages = languages.length > 1;

  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>
        {(multipleLanguages || recordingEnabled) && (
          <div
            className={classNames(multipleLanguages && recordingEnabled ? styles.leftGroup : '')}
            style={{ gap: '20px' }}
          >
            {multipleLanguages && (
              <div data-testid="languages-header" className={styles.col}>
                {t('manager.eventSummary.languages')}
              </div>
            )}

            {recordingEnabled && <div data-testid="recording-header">{t('manager.eventSummary.recording.title')}</div>}
          </div>
        )}

        <div data-testid="vod-header">{t('manager.eventSummary.videoOnDemand.title')}</div>
      </div>

      {languages.map((language) => (
        <div className={styles.row} key={language.code}>
          {(multipleLanguages || recordingEnabled) && (
            <div className={classNames(multipleLanguages && recordingEnabled ? styles.leftGroup : '')}>
              {multipleLanguages && (
                <div className={classNames(styles.ellipsis, styles.language)}>
                  <Paragraph data-testid={`event-summary-language-${language.code}`}>
                    {language.__typename === 'CustomLanguage'
                      ? language.name
                      : t(`common.languages.${getLanguageKey(language.code)}`)}
                  </Paragraph>
                </div>
              )}

              {recordingEnabled && (
                <div className={styles.ellipsis}>
                  <EventSummaryRecording
                    webcast={webcast}
                    language={language.code}
                    multipleLanguages={multipleLanguages}
                  />
                </div>
              )}
            </div>
          )}

          <div data-testid={`vod-container-${language.code}`} className={classNames(styles.ellipsis, styles.onDemand)}>
            <EventSummaryVod webcast={webcast} language={language.code} onVideoSelect={onVideoSelect} />
          </div>
        </div>
      ))}
    </div>
  );
}
